import { AsyncPipe, NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { Toast } from '../../../../models/toast.model';
import { ToastService } from '@era/app';

@Component({
  selector: 'app-toast-container',
  templateUrl: './toast-container.component.html',
  imports: [NgbToastModule, AsyncPipe, NgClass],
  standalone: true,
})
export class ToastContainerComponent {
  toasts$: Observable<Toast[]> = this.toastService.toasts$;
  constructor(private toastService: ToastService) {}
  remove(id: string) {
    this.toastService.remove(id);
  }
}
